<template>
  <div>
    <app-header />
    <mpn-page-title :title="pageTitle" />
    <main class="a-service-main">
      <div class="a-service-container">
        <div class="cont_section">
          <div>
            <div class="box_title_area non_bd">
              <h3 class="service-title-b">
                {{ statusDetail.mypack_name }}
              </h3>
            </div>
            <div class="tab_wrap">
              <ul class="tab_menu">
                <li data-id="con1" :class="menuBtn1" @click="onTabMenuBtn1">
                  주문서
                </li>
                <li data-id="con2" :class="menuBtn2" @click="onTabMenuBtn2">
                  주문내역
                </li>
              </ul>
              <recent-order-sheet
                :status-detail="statusDetail"
                :products-details="productsDetails"
                :products-by-group="productsByGroup"
                :button-states="buttonStates"
                :order-historys="orderHistorys"
                :menu-btn="menuBtn1"
                :reqNo="reqNo"
                @on-order="onOrder"
                @on-cancel-order="onCancelOrder"
                @on-reorder="onReorder"
                @item-state-change="getNewOrderHistory"
                @change-packname="getNewOrderHistory"
              />
              <order-history
                :menu-btn="menuBtn2"
                :order-historys="orderHistorys"
                :req-no="statusDetail.req_no"
                :purchase-type="statusDetail.purchase_type"
                :group-order-info="statusDetail.group_order_list"
                @on-cancel-order="onCancelOrder"
                @delivery-change="getNewOrderHistory"
              />
            </div>
          </div>
        </div>
      </div>
      <modal-cancel-order
        ref="refCancelOrderModal"
        :order-info="statusDetail"
        :order-key="orderKey"
        @confirm="getNewOrderHistory"
      />
      <modal-unavailable-products
        ref="refSoldout"
        :purchase-type="purchaseType"
        :cur-seq="curSeq"
        :re-orderble="reOrderble"
        :re-cal-dose-info="reCalDoseInfo"
        :soldout-products="soldoutProducts"
        @remove-and-proceed="removeAndProceed"
        @cancel-pack="cancelPack"
      />
      <modal-reorder-request
        ref="refReorderModal"
        :purchase-type="purchaseType"
        :req-no="reqNo"
        :mypack-name="mypackName"
      />
      <modal-alert ref="refAlert" />
      <modal-confirm ref="refConfirm" />
    </main>
    <!-- E : main -->
    <app-footer />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { log } from "@/utils/common";
import { PACK_STATUS_CODE } from "@/utils/constants";
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import productHelpers from "@/utils/helpers/product";
import packApi from "@/apis/pack";
import orderApi from "@/apis/order";
import compositionHelpers from "@/utils/helpers/composition";

import mypackHelpers from "@/utils/helpers/mypack";
import OrderHistory from "./partial/OrderHistory.vue";
import RecentOrderSheet from "./partial/RecentOrderSheet.vue";
import ModalCancelOrder from "@/components/modal-popups/ModalCancelOrder.vue";
import ModalUnavailableProducts from "@/components/modal-popups/ModalUnavailableProducts.vue";
import ModalReorderRequest from "@/components/modal-popups/ModalReorderRequest.vue";
import ModalAlert from "@/components/global/ModalAlert.vue";
import ModalConfirm from "@/components/global/ModalConfirm.vue";

// eslint-disable-next-line no-underscore-dangle
let _resolve;

export default {
  name: "MypackDetail",
  components: {
    AppHeader,
    AppFooter,
    OrderHistory,
    RecentOrderSheet,
    ModalCancelOrder,
    ModalReorderRequest,
    ModalUnavailableProducts,
    ModalAlert,
    ModalConfirm,
  },
  async beforeRouteEnter(to, from, next) {
    log("beforeRouteEnter", this);

    const { id } = to.params;
    if (isNaN(id)) {
      next(from.path);
      return;
    }

    const r = await packApi.getApplianceDetail(id);
    if (r.error) {
      next(from.path);
    } else {
      next((vm) => vm.init(r));
    }
  },
  data() {
    return {
      pageTitle: "마이팩 상세",
      statusDetail: {
        mypack_name: "",
      },
      productsDetails: null,
      dataReady: new Promise((resolve) => {
        _resolve = resolve;
      }),
      buttonStates: {},
      menuBtn1: "on",
      menuBtn2: "",
      orderHistorys: [],

      // Stock
      orderlist: null,
      isSoldout: null,
      soldoutSkus: null,
      isEndOfSale: null,
      endOfSaleSkus: null,
      reOrderble: null,
      reCalDoseInfo: null,
      soldoutProducts: null,
    };
  },
  computed: {
    orderKey() {
      if (this.statusDetail.group_order_yn == "Y") {
        return this.statusDetail.group_order_key;
      }
      return this.statusDetail.order_key;
    },
    ...mapGetters({
      products: "product/productsAll",
      productsFetched: "product/productsFetched",
      orderToken: "order/orderToken",
    }),
    productsByGroup() {
      if (this.productsDetails) {
        return productHelpers.splitProductsByDoesGroup(
          this.products,
          this.productsDetails,
          this.productsDetails[0].pockets
        );
      }
      return [];
    },
    purchaseType() {
      return this.statusDetail.purchase_type;
    },
    curSeq() {
      return this.statusDetail.cur_seq;
    },
    reqNo() {
      return this.statusDetail.req_no;
    },
    mypackName() {
      return this.statusDetail.mypack_name;
    },
  },
  watch: {
    productsFetched() {
      if (this.productsFetched) {
        _resolve();
      }
    },
  },
  created() {
    if (this.productsFetched) {
      _resolve();
    }
  },
  methods: {
    async init(r) {
      await this.dataReady;
      const info = r.order_info[0];
      const groupOrderList = r.group_order;
      const appliedStateDetail = {
        mypack_name: info.mypack_name,
        req_no: info.req_no,
        abo_no: info.abo_no,
        apply_no: info.apply_no,
        abc_cd: info.abc_cd,
        abc_name: info.abc_name,
        total_price: info.total_price,
        total_pv: info.total_pv,
        total_bv: info.total_bv,
        take_days: info.take_days,
        req_date: info.re_reg_date,
        order_total_bv: info.order_total_bv,
        order_total_price: info.order_total_price,
        order_total_pv: info.order_total_pv,
        order_key: info.order_key,
        order_date: info.order_date,
        group_order_key: info.group_order_key,
        group_order_yn: info.group_order_yn,
        group_order_list: groupOrderList,
        cfm_kind: info.cfm_kind,
        purchase_type: info.purchase_type,
        cur_seq: info.cur_seq,
        billing_date: info.billing_date,
        billing_period: info.billing_period,
        pack_status: info.pack_status,
        order_status: info.order_status,
        user_status: info.user_status,
        user_status_name: info.user_status_name,
        consulted: info.consulted,
      };
      this.statusDetail = appliedStateDetail;
      this.productsDetails = r.order_detail_list.map((n) => ({
        item_name: n.item_name,
        item_sku: n.item_sku,
        pockets: n.dose,
        seq: n.dose_list,
      }));

      this.orderHistorys = r.order_history;

      const params = {
        userStatus: info.user_status,
        purchaseType: info.purchase_type,
        curSeq: info.cur_seq,
      };
      this.buttonStates = mypackHelpers.getButtonStatesFromUserStatus(params);
    },
    onCancelOrder() {
      this.$refs.refCancelOrderModal.open();
    },
    onTabMenuBtn1() {
      this.menuBtn1 = "on";
      this.menuBtn2 = "";
    },
    onTabMenuBtn2() {
      this.menuBtn2 = "on";
      this.menuBtn1 = "";
    },
    async getNewOrderHistory() {
      const r = await packApi.getApplianceDetail(this.statusDetail.req_no);
      if (r.error) {
        return;
      }
      this.orderHistorys = r.order_history;
      const info = r.order_info[0];
      const groupOrderList = r.group_order;
      this.statusDetail = {
        mypack_name: info.mypack_name,
        req_no: info.req_no,
        abo_no: info.abo_no,
        apply_no: info.apply_no,
        abc_cd: info.abc_cd,
        abc_name: info.abc_name,
        total_price: info.total_price,
        total_pv: info.total_pv,
        total_bv: info.total_bv,
        take_days: info.take_days,
        req_date: info.re_reg_date,
        order_total_bv: info.order_total_bv,
        order_total_price: info.order_total_price,
        order_total_pv: info.order_total_pv,
        order_key: info.order_key,
        order_date: info.order_date,
        group_order_key: info.group_order_key,
        group_order_yn: info.group_order_yn,
        group_order_list: groupOrderList,
        cfm_kind: info.cfm_kind,
        purchase_type: info.purchase_type,
        cur_seq: info.cur_seq,
        billing_date: info.billing_date,
        billing_period: info.billing_period,
        pack_status: info.pack_status,
        order_status: info.order_status,
        user_status: info.user_status,
        user_status_name: info.user_status_name,
        consulted: info.consulted,
      };
      
      this.productsDetails = r.order_detail_list.map((n) => ({
        item_name: n.item_name,
        item_sku: n.item_sku,
        pockets: n.dose,
        seq: n.dose_list,
      }));
      
      this.orderHistorys = r.order_history;

      const params = {
        userStatus: info.user_status,
        purchaseType: info.purchase_type,
        curSeq: info.cur_seq,
      };
      this.buttonStates = mypackHelpers.getButtonStatesFromUserStatus(params);
    },
    // 즉시 결제
    async onOrder() {
      const r = await orderApi.getPreOrderInfo(this.reqNo);
      log("reqNo :::::::::::::::::", this.reqNo);
      log("r :::: ", r);
      if (r.msg) {
        await this.$refs.refAlert.openWithMessage(
          "월 주문 가능 횟수를 초과했습니다."
        );
        return;
      }

      // 주문 불가 제품이 존재하는 경우
      if (r.isSoldout || r.isEndOfSale) {
        // await this.init(r.orderlist);
        await this.checkSoldoutProducts(r);
        return;
      }

      if (r.error) {
        console.log(r);
        return;
      }
      
      // reset terms
      this.$store.commit("terms/reset");

      const amwayPayMethods = await orderApi.getAmwayPayMethods();
      this.$router.push({
        name: "order",
        params: {
          orderInfo: r,
          amwayPayMethods: amwayPayMethods,
        },
      });
    },
    async checkSoldoutProducts(r) {
      // this.productsDetails = r.orderlist.order_detail_list.map((n) => ({
      //   item_name: n.item_name,
      //   item_sku: n.item_sku,
      //   pockets: n.dose,
      //   seq: n.dose_list,
      // }));

      this.orderlist = r.orderlist;
      this.isSoldout = r.isSoldout;
      this.soldoutSkus = r.soldoutSkus;
      this.isEndOfSale = r.isEndOfSale;
      this.endOfSaleSkus = r.endOfSaleSkus;
      this.reOrderble = r.reOrderble;
      this.reCalDoseInfo = r.reCalDoseInfo;
      this.soldoutProducts = productHelpers.getSoldoutProducts(
        this.products,
        this.productsDetails,
        r.soldoutSkus,
        r.endOfSaleSkus
      );

      await this.$refs.refSoldout.open();
    },
    async removeAndProceed() {
      try {
        await this.$refs.refConfirm.openWithMessage(
          "단종 또는 일시품절 등의 제품을 제외하고 마이팩을 주문하시겠습니까?"
        );
        const r = await orderApi.removeSoldOut(
          "D",
          [...this.soldoutSkus, ...this.endOfSaleSkus],
          this.reqNo
        );
        await this.$refs.refSoldout.onDispose();
        await this.onOrder();
      } catch (e) {
        console.log(e);
      }
    },
    async cancelPack() {
      if (this.purchaseType == "single") {
        try {
          await this.$refs.refConfirm.openWithMessage(
            "단종 또는 일시품절 등의 제품으로 인해 마이팩 구매를 취소하시겠습니까?"
          );
          const r = await packApi.cancelConsultationApplied(this.reqNo);
          if (r) {
            await this.$refs.refAlert.openWithMessage(
              "마이팩이 취소되었습니다."
            );
            await this.$refs.refSoldout.onDispose();
            await this.$router.push("/");
          }
        } catch (e) {}
      } else if (this.purchaseType == "recurring") {
        if (this.isEndOfSale) {
          try {
            await this.$refs.refConfirm.openWithMessage(
              "정기 구매 제품 중 단종 제품이 포함되어 있어, 전체 주문이 취소 처리 됩니다. 정기구매를 취소하시겠습니까?"
            );
            // 정기 구매 취소
            const r = await packApi.cancelConsultationApplied(this.reqNo);
            if (r) {
              await this.$refs.refAlert.openWithMessage(
                "마이팩 정기구매가 취소되었습니다."
              );
              await this.$refs.refSoldout.onDispose();
              await this.$router.push("/");
            }
          } catch (e) {}
        } else if (this.isSoldout) {
          try {
            await this.$refs.refConfirm.openWithMessage(
              "정기 구매 제품 중 일시품절 제품이 포함되어 있어, 이번 회차에 한해 취소 처리 됩니다. 이번 회차 주문을 취소하시겠습니까?"
            );
            // 정기 구매 승인 후 TNA
            const r = await packApi.cancelPackRecurringThisMonth(this.reqNo);
            if (r) {
              await this.$refs.refAlert.openWithMessage(
                `이번 회차의 주문이 취소되었습니다.<span class="desc">* 간편 상담은 완료 되었으므로, 재고가 있는 경우 마이팩 관리에서 '재고 확인 및 결제' 버튼을 통해 즉시결제 가능합니다.</span>`
              );
              await this.$refs.refSoldout.onDispose();
              await this.$router.push("/");
            }
          } catch (e) {}
        }
      }
    },
    async onReorder() {
      if(!this.statusDetail.consulted) {
        const r = await packApi.getApplianceDetail(this.reqNo, true);
        if (r.error) {
          return;
        }

        const {
          req_no,
          take_days,
          purchase_type,
          abc_cd,
          cfm_kind,
          billing_date,
          billing_status,
          consulted,
        } = r.order_info[0];

        // 조회한 팩 상태가 승인 상태라면 재주문 레이어 팝업 수행
        if(consulted) {
          await this.$refs.refReorderModal.open();
          return;
        }

        const subscription = {
          purchaseType: purchase_type,
          abcCd: abc_cd,
          requestType: cfm_kind,
          billingDate: billing_date,
          billingStatus: purchase_type == 'recurring' ? 'ACTIVE' : '',
          isConsultation: false,
        };

        const finalSkus = r.order_detail_list.map((n) => ({
          days: take_days,
          item_sku: n.item_sku,
          pockets: n.dose,
          seq: n.dose_list,
        }));

        const reqNo = req_no;
        await compositionHelpers.doReorderFromMypack(
          this.$store,
          r,
          subscription,
          finalSkus,
          reqNo,
        );
        await this.$router.push("/agreement/composition-reorder");
      } else {
        await this.$refs.refReorderModal.open();
      }
    },
  },
};
</script>
